import { DatePicker } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { COLLECTION_STATUSES } from '../../../types';
import { RadioGroup, RadioItem } from '../../../../../ui/forms/Radio';
import { SecondHeader } from '../../../../../ui/Headers';
import Input from "../../../../../ui/forms/Input";

const { RangePicker } = DatePicker;

const CollectionStatuses = ['All', ...Object.keys(COLLECTION_STATUSES)];

interface CollectionReportProps {
  onChangeFilter: (filter: keyof typeof COLLECTION_STATUSES | null) => void;
  onChangeID: (filter: string) => void;

  onChangeTimePeriod: (period: [string, string]) => void;
  nameFilter: string;
  idFilter: string;
  setNameFilter: (name: string) => void;
}

export default function CollectionReport({ onChangeFilter, onChangeTimePeriod, nameFilter, setNameFilter, idFilter, onChangeID }: CollectionReportProps) {
  const [typeOfCollection, setTypeOfCollection] = useState<(typeof CollectionStatuses)[number]>('All');

  const onFilterClickHandler = (status: string) => {
    if (status === 'All') {
      onChangeFilter(null);
    } else {
      onChangeFilter(status as keyof typeof COLLECTION_STATUSES);
    }
  };

  return (
    <>
      <SecondHeader>Collections Report</SecondHeader>
      <InputWrapper>
        <InputStyledID placeholder="Find by ID:" value={idFilter} onChange={(e) => onChangeID(e.target.value)}/>
        <InputStyled placeholder="Find by name:" value={nameFilter} onChange={(e) => setNameFilter(e.target.value)}/>
      </InputWrapper>
      <Filter>
        <div>
          Collection status:
          <FilterGroup value={typeOfCollection} onChange={(e) => setTypeOfCollection(e.target.value)}>
            {CollectionStatuses.map((status) => (
              <FilterItem onClick={() => onFilterClickHandler(status)} value={status}>{status}</FilterItem>
            ))}
          </FilterGroup>
        </div>
        <RangePicker onChange={(_e, period) => onChangeTimePeriod(period)} picker="month" />
      </Filter>
    </>
  );
}

const Filter = styled.div`
  //margin-top: 41px;
  margin-top: 21px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FilterGroup = styled(RadioGroup)`
  margin-left: 14px;
`;

const FilterItem = styled(RadioItem)`
  margin-left: 18px;
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

const InputStyled = styled(Input)`
  width: 255px;
  height: 34px;
  background: #FFFFFF;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 14px;
  padding: 0 25px 0 25px;
`;

const InputStyledID = styled(Input)`
  width: 130px;
  height: 34px;
  background: #FFFFFF;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 14px;
  padding: 0 25px 0 25px;
`;
